export default function retry(func: AnyFn, interval: number = 1000): () => void {
  const intervalId = setInterval(func, interval)
  return () => {
    clearInterval(intervalId)
  }
}
